import { useEffect, useRef } from 'react';

import { useAnalyticsService } from '@/app/providers/analytics-service/hooks';

import { FPSMeter } from './fps-meter';

const METRICS_INTERVAL = 10000;
const SAMPLE_SIZE = 100; // Количество измерений для медианы

export function useFPSMeter() {
  const fpsRef = useRef(0);
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    if (import.meta.env.DEV) return;

    const fpsMeter = new FPSMeter();
    let measurementsCount = 0;

    const measureInterval = setInterval(() => {
      fpsRef.current = fpsMeter.getMedianFPS();
      measurementsCount++;
    }, 100);

    const reportInterval = setInterval(() => {
      if (measurementsCount >= SAMPLE_SIZE) {
        analyticsService.send({
          type: 'performance_metric',
          created: Date.now(),
          user_properties: {},
          event_properties: {
            fps: fpsRef.current,
            duration: METRICS_INTERVAL,
            samples: measurementsCount,
          },
        });
      }
    }, METRICS_INTERVAL);

    return () => {
      clearInterval(measureInterval);
      clearInterval(reportInterval);
    };
  }, [!!analyticsService]);
}
